<template>
  <section>
    <v-layout row wrap>
       <v-flex xs4>
        <v-select
          :items="tiposDoc"
          v-model="tipo_documento"
          label="Tipo de documento"
          item-text="text"
          item-value="value"
          :rules="$validate(['required'])"
          required
          class="required"
          ></v-select>
      </v-flex>
      <v-flex xs3>
        <v-text-field
          label="Número de documento"
          v-model="nro_documento"
          maxlength="20"
          @keydown.native="$filter.numeric($event)"
          :rules="$validate(['required'])"
          required
          class="required"
          ></v-text-field>
      </v-flex>
      <v-flex :class="change ? 'xs3' : 'xs5'">
        <select-date
          label="Fecha de nacimiento"
          model="form.fecha_nacimiento"
          :store="store"
          :required="true"
          class="required"
          :max-year="parseInt(this.$datetime.now(false, 'YYYY'))"
          :value="$store.state.date['form.fecha_nacimiento']"
        >
        </select-date>
      </v-flex>
      <v-flex xs4>
        <v-text-field
          label="Nombre(s)"
          v-model="nombres"
          maxlength="100"
          :rules="$validate(['required'])"
          class="required"
          required
          ></v-text-field>
      </v-flex>

      <v-flex xs4>
        <v-text-field
          label="Primer apellido"
          v-model="primer_apellido"
          :rules="$validate(['required'])"
          maxlength="100"
          required
          ></v-text-field>
      </v-flex>

      <v-flex xs4>
        <v-text-field
          label="Segundo apellido"
          v-model="segundo_apellido"
          maxlength="100"
          ></v-text-field>
      </v-flex>

      <v-flex xs4>
        <v-autocomplete
          :items="nacionalidades"
          v-model="nacionalidad"
          label="Nacionalidad"
          item-text="text"
          item-value="value"
          :rules="$validate(['required'])"
          required
          class="required"
          ></v-autocomplete>
      </v-flex>

      <!-- <v-flex xs4>
        <v-select
          :items="paises"
          v-model="pais_nacimiento"
          label="País de nacimiento"
          item-text="text"
          item-value="id"
          :rules="$validate(['required'])"
          required
          autocomplete
          ></v-select>
      </v-flex> -->

      <!-- <v-flex xs4>
        <v-text-field
          label="Móvil"
          prepend-icon="smartphone"
          v-model="movil"
          maxlength="30"
          :disabled="!persona"
          ></v-text-field>
      </v-flex> -->

      <v-flex xs4>
        <v-text-field
          label="Teléfono"
          prepend-icon="phone"
          v-model="telefono"
          maxlength="30"
          ></v-text-field>
      </v-flex>

      <v-flex xs4>
        <v-radio-group
          v-model="genero"
          row
          :rules="$validate(['required'])"
          required
          class="required"
        >
          <v-radio
            label="Mujer"
            value="FEMENINO"
          ></v-radio>
          <v-radio
            label="Hombre"
            value="MASCULINO"
          ></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
import SelectDate from '@/common/util/SelectDate';
import PersonaSegip from '@/components/admin/persona/PersonaSegip';
import validate from '@/common/mixins/validate';
import paises from '@/common/mixins/paises';
import { mapFields } from 'vuex-map-fields';

export default {
  mixins: [ validate, paises ],
  props: {
    store: {
      type: String,
      default: ''
    },
    change: {
      type: Boolean,
      default: true
    },
    db: {
      type: Boolean,
      default: false
    }
  },
  created () {
    let items = this.getPaises();
    let paises = [];
    let nacionalidades = [];
    items.map(item => {
      paises.push({ value: item.pais, text: item.pais });
      nacionalidades.push({ value: item.nacionalidad, text: item.nacionalidad });
    });
    this.paises = paises;
    this.nacionalidades = nacionalidades;
  },
  data () {
    return {
      paises: [],
      nacionalidades: [],
      valid: false,
      tiposDoc: [
        { value: 'CI', text: 'CÉDULA DE IDENTIDAD' },
        { value: 'PASAPORTE', text: 'PASAPORTE' }
      ]
    };
  },
  beforeCreate () {
    // Creando campos del formulario en el store definido
    let store = this.$options.propsData.store || '';
    this.$options.computed = {
      ...mapFields([
        'form.nombres',
        'form.primer_apellido',
        'form.segundo_apellido',
        'form.telefono',
        'form.nacionalidad',
        'form.tipo_documento',
        'form.genero',
        'form.fecha_nacimiento',
        'form.nro_documento',
        'form.persona'
      ], `${store}getField`, `${store}updateField`)
    };
  },
  components: {
    PersonaSegip,
    SelectDate
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/persona/PersonaForm.vue